import { render, staticRenderFns } from "./VatsTab.vue?vue&type=template&id=4a07962d&"
import script from "./VatsTab.vue?vue&type=script&lang=ts&"
export * from "./VatsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports